import { render, staticRenderFns } from "./TaxFormBlock.vue?vue&type=template&id=113799f8&"
import script from "./TaxFormBlock.vue?vue&type=script&lang=js&"
export * from "./TaxFormBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports